import { render } from "./Global.component.vue?vue&type=template&id=458eedb2&scoped=true&ts=true"
import script from "./Global.component.vue?vue&type=script&lang=ts"
export * from "./Global.component.vue?vue&type=script&lang=ts"

import "./Global.component.vue?vue&type=style&index=0&id=458eedb2&lang=scss&scoped=true"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458eedb2"]])

export default __exports__